import { Button, Space, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useReducer, useState } from "react";
import { fetchProFormaInvoices } from "../../apis/pro_forma_invoice.api";

export default function Checkout() {
  const [paymentPendingEstimates, setPaymentPendingEstimates] = useState<any[]>(
    []
  );
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useReducer((x: number) => x + 1, 0);

  useEffect(() => {
    setLoading(true);
    fetchProFormaInvoices({
      estimate_status: "payment_pending",
      page,
      page_size: pageSize,
    }).then((res) => {
      setPaymentPendingEstimates(res?.results);
      setTotal(res?.count);
      setLoading(false);
    });
  }, [page, pageSize, refresh]);

  const columns = [
    {
      title: "Lead ID",
      dataIndex: "lead_id",
      key: "lead_id",
    },
    {
      title: "Client Name",
      key: "client_name",
      render: (record: any) => {
        return record?.client?.f_name;
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (datar: any) => {
        return dayjs(datar).format("YYYY-MM-DD HH:mm");
      },
    },
    {
      title: "Total Amount",
      dataIndex: "total_estimate_amount",
      key: "total_amount",
    },
    {
      title: "Actions",
      render: (record: any) => {
        return (
          <Space>
            <Button
              type="primary"
              onClick={() => {
                window.open(
                  `https://materialdepot.in/auto-login-v2?use_procurement_user_login=${record?.client?.id}&use_procurement_user_contact=${record?.client?.contact}&redirect_path=/user/cart`
                );
              }}
            >
              Open Website Checkout
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div className="mx-3 my-3 px-3 py-2 white-color-bg">
        <div className="d-flex justify-content-between mb-3">
          <h3>Checkout User Carts</h3>
          <Button
            type="primary"
            onClick={() => {
              setRefresh();
            }}
            loading={loading}
          >
            Refresh
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={paymentPendingEstimates}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: total,
            onChange: (page, pageSize) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
          loading={loading}
          rowKey={(record) => record.id}
        />
      </div>
    </>
  );
}
